<template>
  <main id="app" class="wh100">
    <main-menu />
    <router-view/>
  </main>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue